import { render, staticRenderFns } from "./ReceiptDetail.vue?vue&type=template&id=5999654a&scoped=true"
import script from "./ReceiptDetail.vue?vue&type=script&lang=js"
export * from "./ReceiptDetail.vue?vue&type=script&lang=js"
import style0 from "./ReceiptDetail.vue?vue&type=style&index=0&id=5999654a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5999654a",
  null
  
)

export default component.exports